export const RootPrefix = 'cart_page'; // don't change its value
export const PriceConfigPrefix = 'price_config_form';
